import { Container, Row, Col, Breadcrumb, BreadcrumbItem } from "reactstrap";
import { Home } from "react-feather";
import { Link } from "react-router-dom";
import { useKeycloak } from "@react-keycloak/web";
import styles from "./breadCrumb.module.scss";
const Breadcrumbs = props => {
  const keycloak = useKeycloak().keycloak;
  return (
    <Container fluid>
      <div className={styles["breadcrumb_wrapper"] + " page-title"}>
        <Row>
          <Col xs="12">
            <Breadcrumb>
              <BreadcrumbItem>
                <Link to={keycloak.authenticated ? `/training-paths` : `/`}>
                  <Home />
                </Link>
              </BreadcrumbItem>
              {props.parent && (
                <BreadcrumbItem>
                  <Link to={keycloak.authenticated ? `/training-paths` : `/`}>{props.parent}</Link>
                </BreadcrumbItem>
              )}
              {props.title && <BreadcrumbItem active>{props.title}</BreadcrumbItem>}
            </Breadcrumb>
          </Col>
        </Row>
      </div>
    </Container>
  );
};

export default Breadcrumbs;
